import handleResponse from './request/handleResponse'

export default function fetchWidget(api: GlobalFetch) {
  return async function(objectId) {
    const buildUrl = `/api/v2/widget/index/id_object/${objectId}`
    const response = await api.fetch(buildUrl)

    return await handleResponse(response)
  }
}

export interface IData {
  messages: string[]
  items: IItemData[]
}

export interface IItemData {
  id: string
  id_user: string
  id_object: string
  id_calendar: string
  subdomain: string
  show_food: string
  no_reservation_online: string
  show_calendar: string
  show_food_bb: string
  show_food_hb: string
  show_food_fb: string
  hide_link: string
  widget_color: string
  show_kids_price: string
  regulation_setting: string
  regulation_url: string
  regulation_text: string
  privacy_setting: string
  privacy_url: string
  privacy_text: string
  api_key: string
  created_at: string
  updated_at: string
  language: string
  block_reservations: string
}
